export enum RESTRICTION_TYPES {
  ENFORCEMENTS = 'enforcements'
}
